import React, { useEffect } from 'react'
import shortid from "shortid";
import MyComponent from '../components/MyComponent';
import { useDispatch } from 'react-redux';
import { GetBlogPageThemeAction } from '../middleware/GetBlogPageThemeAction';

function BlogPage(props) {
    
       const dispatch = useDispatch();
       var state = props.state;
        var contentId = state.contentId
        var pagewidth = state.attributes.width
        var themeMap = state.themeMap
        useEffect(()=>{
            if(state.themeMap){
                dispatch(GetBlogPageThemeAction(themeMap));
            }
        },[state.themeMap])
        const stylesObj = {
            width: pagewidth
        };
        return (
            <>
                {/* Header content  */}
                <div className="containerWarp" data-cont-id={contentId ? contentId : ""} data-zone="BlogHeaderContent" >
                    <div className="primary-zone" data-zone="BlogHeaderContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="BlogHeaderContent" >
                            <div className="content row gx-0 p-0 justify-content-around mobile-width-style" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="BlogHeaderContent">
                                {state.contents && state.contents.BlogHeaderContent ? state.contents.BlogHeaderContent.map(content => {
                                    let headerContentType = content['@type'];
                                   return (
                                        <MyComponent type={headerContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="BlogHeaderContent" templateName={headerContentType} />
                                    )
                                }
                                ) : ""}
                            </div>
                        </div>
                    </div>
                </div>

                {/* FullWidth Header Content */}
                <div className="containerWarp" data-cont-id={contentId ? contentId : ""} data-zone="BlogFullWidthHeaderContent" >
                    <div className="primary-zone" data-zone="BlogFullWidthHeaderContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="BlogFullWidthHeaderContent" >
                            <div className="content row gx-0 justify-content-around mobile-width-style box-shadow-main" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="BlogFullWidthHeaderContent">

                                {state.contents.BlogFullWidthHeaderContent ? (
                                    state.contents.BlogFullWidthHeaderContent.map(content => {
                                        let fullWidthHeaderContentType = content['@type'];
                                        return (
                                            <MyComponent type={fullWidthHeaderContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="BlogFullWidthHeaderContent" templateName={fullWidthHeaderContentType} />
                                        )
                                    })
                                ) : (
                                    <></>
                                )}
                            </div>


                        </div>
                    </div>
                </div>

                {/* Main content  */}
                <div className="containerWarp" data-cont-id={contentId ? contentId : ""} data-zone="BlogMainContent" >
                    <div className="primary-zone" data-zone="BlogMainContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="BlogMainContent" >
                            {/* added new class for vastproSite padding issue (vastpro-p-0) */}

                            <div className="content row container-fluid  justify-content-around gx-0 p-0  mobile-width-style" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="BlogMainContent">
                                {state.contents.BlogMainContent.map(content => {
                                    let contentType = content['@type'];
                                    return (
                                        <MyComponent type={contentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="BlogMainContent" templateName={contentType} />
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer content  */}
                <div className="containerWarp" data-cont-id={contentId ? contentId : ""} data-zone="BlogFooterContent" >
                    <div className="primary-zone" data-zone="BlogFooterContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="BlogFooterContent" >
                            <div className="content row px-0 justify-content-around mobile-width-style box-shadow-footer" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="BlogFooterContent">
                                {/* <NavbarHeader/>                    */}
                                {state.contents && state.contents.BlogFooterContent.map(content => {
                                    let FooterContentType = content['@type'];
                                    return (
                                        <MyComponent type={FooterContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="BlogFooterContent" templateName={FooterContentType} />
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

export default BlogPage
